import React from "react";
import AccountStatusBadge from "../../Dashboard/components/AutopayAccountStatusBadge";
import {
  formatPaymentMethodLabel,
  getPaymentMethodStatusBadgeVariant,
} from "../utils";

type PaymentMethodSourceLabelProps = {
  paymentMethod: {
    providerName: string;
    last4: string;
    type: string;
    expiryDate?: string | null;
    status?: string | null;
  };
  showAutopayBadge?: boolean;
  /** Set false where the surrounding layout already has a dedicated expiration column. */
  showExpiry?: boolean;
  className?: string;
};

export const PaymentMethodSourceLabel: React.FC<PaymentMethodSourceLabelProps> = ({
  paymentMethod,
  showAutopayBadge = false,
  showExpiry = true,
  className = "",
}) => {
  const statusBadgeVariant = getPaymentMethodStatusBadgeVariant(paymentMethod);
  const expiryText =
    showExpiry && paymentMethod.type === "CREDIT_CARD" && paymentMethod.expiryDate
      ? ` · Exp ${paymentMethod.expiryDate}`
      : "";

  return (
    <span className={`payment-method-source-cell ${className}`.trim()}>
      <span className="payment-method-source-label">
        {formatPaymentMethodLabel(paymentMethod)}
        {expiryText}
      </span>
      {(showAutopayBadge || statusBadgeVariant) && (
        <span className="payment-method-source-badges">
          {showAutopayBadge && (
            <AccountStatusBadge
              variant="autopay"
              className="payment-method-status-badge"
            />
          )}
          {statusBadgeVariant && (
            <AccountStatusBadge
              variant={statusBadgeVariant}
              className="payment-method-status-badge"
            />
          )}
        </span>
      )}
    </span>
  );
};
